import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { ToolbarCollectionErrorStateUniDriver } from '../ErrorState/ToolbarCollectionErrorState.uni.driver';
import { ToolbarCollectionEmptyStateUniDriver } from '../EmptyState/ToolbarCollectionEmptyState.uni.driver';
import { CollectionToolbarUniDriver } from '../CollectionToolbar/CollectionToolbar.uni.driver';
import { AppliedFiltersTagListUniDriver } from '../AppliedFiltersTagList/AppliedFiltersTagList.uni.driver';
import InfiniteScrollTableUniDriver from '../InfiniteScrollTable/InfiniteScrollTable.uni.driver';
import { SummaryBarUniDriver } from '../SummaryBar/SummaryBar.uni.driver';

export function TableFoldersUniDriver(base: UniDriver, body: UniDriver) {
  const toolbarBase = () => base.$('[data-hook="collection-toolbar"]');

  const toolbar = () => CollectionToolbarUniDriver(toolbarBase(), body);

  const table = InfiniteScrollTableUniDriver(base, body);

  const loadingStateExists = () =>
    base.$('[data-hook="placeholder-states-loading-state"]').exists();
  const getSummaryBar = () => SummaryBarUniDriver(base, body);

  return {
    ...table,
    toolbar: () => toolbar(),
    getErrorStateByDataHook: (dataHook = 'placeholder-states-error-state') =>
      ToolbarCollectionErrorStateUniDriver(
        base.$(`[data-hook="${dataHook}"]`),
        body,
      ),
    getEmptyStateByDataHook: (dataHook = 'placeholder-states-empty-state') =>
      ToolbarCollectionEmptyStateUniDriver(
        base.$(`[data-hook="${dataHook}"]`),
        body,
      ),

    loadingStateExists,
    /** @deprecated use loadingStateExists */
    refreshLoaderExists: loadingStateExists,
    /** @deprecated use loadingStateExists */
    initialLoaderExists: loadingStateExists,
    folderIconExistsAt: async (row: number, col = 0) =>
      (await table.getCellByIndex(row, col))
        .$('[data-hook="folder-icon"]')
        .exists(),

    avatarExistsAt: async (row: number, col: number) =>
      (await table.getCellByIndex(row, col))
        .$('[data-hook="item-avatar"]')
        .exists(),

    subToolbar: () =>
      AppliedFiltersTagListUniDriver(
        base.$('[data-hook="collection-table-sub-toolbar"]'),
        body,
      ),
    /**
     * Gets collection summary bar
     */
    getSummaryBar,
  };
}

export default TableFoldersUniDriver;
